/**
 * Production canonical URL utilities for ShoreSight Marine
 * All canonical tags point to the www subdomain
 */

export const PRODUCTION_BASE_URL = "https://www.shoresightmarine.com";

/**
 * Page ID to path mapping for dynamic SEO pages
 */
const PAGE_PATH_MAP: Record<string, string> = {
  home: "/",
  "thank-you": "/thank-you",
  terms: "/terms",
  privacy: "/privacy",
};

/**
 * Get the full production URL for a given page path
 */
export const getProductionUrl = (path: string): string => {
  const cleanPath = path === "/" ? "" : path;
  return `${PRODUCTION_BASE_URL}${cleanPath}`;
};

/**
 * Get the production URL for a page ID (used by useSEO hook)
 */
export const getProductionUrlForPageId = (pageId: string): string => {
  const path = PAGE_PATH_MAP[pageId] || "/";
  return getProductionUrl(path);
};

/**
 * Update or create the canonical link tag in the document head
 */
export const updateCanonicalTag = (url: string): void => {
  let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;

  if (link) {
    link.href = url;
  } else {
    link = document.createElement("link");
    link.rel = "canonical";
    link.href = url;
    document.head.appendChild(link);
  }
};
